export default __webpack_public_path__ + "static/media/keyvisual-wuppertal.71efdb7d.jpg";